import React, { Component } from 'react';
import { FacebookShareButton, EmailShareButton, PinterestShareButton } from 'react-share';
import LinkCopierContainer from '../../../global/LinkCopierContainer';
import PropTypes from 'prop-types';
import withArticleTracking from '../../../common/withArticleTracking';
import { decodeTags, isValid, sendLog } from '../../../../utils';
import './pull-quote.scss';

class ShareModal extends Component {
  render() {
    const { buttons=[], article={}, module=null } = this.props;
    let shareButton = null;
    const TrackedFacebookShareButton = withArticleTracking(FacebookShareButton);
    const TrackedPinterestShareButton = withArticleTracking(PinterestShareButton);
    const TrackedEmailShareButton = withArticleTracking(EmailShareButton);
    const articleUrl = (isValid(article.articleUrl)) ? article.articleUrl : null;
    const articleHeadline = (isValid(article.headline)) ? article.headline : null;
    const articleImg = (isValid(article.heroImage.imageSrcDesktop)) ? article.heroImage.imageSrcDesktop : null;

    const renderedButtons = buttons.map((button, i) => {

      switch (button) {
        case 'facebook':
          shareButton = <TrackedFacebookShareButton
            key={i}
            url={articleUrl}
            quote={articleHeadline}
            wrapperClassName="share-button facebook-button"
            dataEventName="article_shared"
            actionType="facebook_share"
            moduleName="pull-quote"
            onClick={() => analytics.track('Social Share', {action_type: 'facebook'})}>
            </TrackedFacebookShareButton>;
          break;
        case 'pinterest':
          shareButton = <TrackedPinterestShareButton
            key={i}
            url={articleUrl}
            media={articleImg}
            wrapperClassName="share-button pinterest-button"
            dataEventName="article_shared"
            actionType="pinterest_share"
            moduleName="pull-quote"
            onClick={() => analytics.track('Social Share', {action_type: 'pinterest'})}>
          </TrackedPinterestShareButton>;
          break;
        case 'email':
          shareButton = <TrackedEmailShareButton
            key={i}
            url={articleUrl}
            media={articleImg}
            wrapperClassName="share-button email-button"
            dataEventName="article_shared"
            actionType="email_share"
            moduleName="pull-quote"
            onClick={() => analytics.track('Social Share', {action_type: 'email'})}>
          </TrackedEmailShareButton>;
          break;
        case 'copy-link':
          shareButton = 
            <LinkCopierContainer module={module} />
          break;
        case 'print':
          shareButton = 
            <span className="share-button print-button" />
          break;
        default:
          shareButton;
      }
      return (shareButton);
    });

    return (
      <div className={`share-buttons-container ${module}`}>
        {renderedButtons}
      </div>
    );
  }
}

ShareModal.propTypes = {
  buttons: PropTypes.array,
  articleUrl: PropTypes.string,
};

export default ShareModal;
